import * as CreateAccountRules from '../../utils/FormValidationRules';

export const usernameCheck = value => {
  switch (false) {
    case CreateAccountRules.ContainOneLetterRule(value):
    case CreateAccountRules.UsernameLengthRule(value): {
      return {
        error_code: 'USERNAME_FIELD_ERROR_IN_CREATE_ACCOUNT',
        trafficEidSuffix: 'validation',
      };
    }
    case CreateAccountRules.NoInnerSpacesRule(value): {
      return {
        error_code: 'CANNOT_CONTAIN_SPACE',
        trafficEidSuffix: 'validation',
      };
    }
    case CreateAccountRules.NoOuterWhitespaceRule(value): {
      return {
        error_code: 'CANNOT_CONTAIN_SPACE',
        trafficEidSuffix: 'validation',
      };
    }
    default: {
      return null;
    }
  }
};

export const emailCheck = (value, isUsername = false) => {
  switch (false) {
    case CreateAccountRules.EmailFormatRule(value): {
      return {
        error_code: isUsername ? 'VALID_EMAIL_PASS' : 'EMAIL_VALID_FORMAT_ERROR',
        trafficEidSuffix: 'validation',
        rules: { valid_email: false },
      };
    }
    default: {
      return null;
    }
  }
};

export const passwordCheck = (value, isPasswordStrengthValidationEnabled, passwordStrength) => {
  switch (false) {
    case CreateAccountRules.MinCharactersRule(value): {
      return {
        error_code: 'PASSWORD_MUST_BE_NINE_CHARS_LONG',
        trafficEidSuffix: 'validation',
      };
    }
    case CreateAccountRules.PasswordValid(value, isPasswordStrengthValidationEnabled, passwordStrength): {
      return {
        trafficEidSuffix: 'validation',
      };
    }
    default: {
      return null;
    }
  }
};

export const checkConfirmPassword = (password, confirmPassword) => {
  if (password !== confirmPassword) {
    return {
      error_code: 'PASSWORD_MUST_MATCH',
      trafficEidSuffix: 'validation',
    };
  }

  return null;
};
